module.exports = __webpack_public_path__ + "static/noise-563cdcf1aba2b77cb4cbcfc8a5f70d79.png";